import { routes } from '@/config/routes'
import { useMixpanel } from '@/context/mixpanel'
import { useEffect, useState } from 'react'
import { generatePath, useNavigate } from 'react-router'
import type { Address } from 'viem'
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '../common/dialog'
import { Separator } from '../common/separator'
import { ConnectModal } from '../connect/connectModal'
import { AddressForm } from './addressForm'

interface Props {
  address?: Address
}

export const TrackPortfolioDialog = ({ address }: Props) => {
  const { trackEvent } = useMixpanel()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setOpen(true), 500)
    return () => clearTimeout(timer)
  }, [])

  function handleRejectTrack() {
    navigate(generatePath(routes.root))
    trackEvent('Track wallet rejected')
  }

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && handleRejectTrack()}>
      <DialogContent position="center" onEscapeKeyDown={handleRejectTrack}>
        <DialogBody>
          <div className="flex flex-col gap-4 p-5 pt-8 md:p-8 md:pt-16">
            <DialogHeader>
              <DialogTitle>Track your portfolio</DialogTitle>
            </DialogHeader>
            <p>Enter the address or ENS of your wallet or connect a wallet to see the details of its performance.</p>
            <AddressForm address={address} />
            {!address && (
              <>
                <div className="flex w-full items-center gap-3">
                  <Separator className="w-auto flex-grow" />
                  <span className="text-nowrap text-center text-xs">or</span>
                  <Separator className="w-auto flex-grow" />
                </div>
                <ConnectModal
                  triggerVariant="secondary"
                  action="connect"
                  className="h-12 w-full"
                  onClick={() => trackEvent('Track wallet', { Method: 'Connect' })}
                />
              </>
            )}
          </div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
